import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

const numericParam = (searchParams, key) => {
  const value = searchParams.get(key);
  if (!value || !/^\d+$/.test(value)) {
    return undefined;
  }

  return Number(value);
};

export const usePhdDashboardPrefill = () => {
  const [searchParams] = useSearchParams();

  return useMemo(
    () => ({
      phd_student_id: numericParam(searchParams, 'phd_student_id'),
      phd_dissertation_exam_application_id: numericParam(
        searchParams,
        'phd_dissertation_exam_application_id',
      ),
      phd_dissertation_defense_application_id: numericParam(
        searchParams,
        'phd_dissertation_defense_application_id',
      ),
    }),
    [searchParams],
  );
};
